export default __webpack_public_path__ + "static/media/password.f42894c6.svg";